import React, { ReactNode, useEffect, useRef, useState } from "react"
import cx from "classnames"
import "./Carousel.css"

const Carousel = ({
    children,
    timeout,
    itemsPerPage = 1,
    contentClassName = "",
    innerPaginator = false,
    className = "",
    onPageChange,
}: {
    children: ReactNode
    contentClassName?: string
    className?: string
    timeout: number
    itemsPerPage: number
    innerPaginator?: boolean
    onPageChange?: (page: number) => void
}) => {
    const [page, setPage] = useState(1)
    const interval = useRef<NodeJS.Timer>()

    const childrenArray = React.Children.toArray(children)
    const [animationClass, setanimationClass] = useState<"slide-in-right" | "slide-in-left">("slide-in-right")

    useEffect(() => {
        if (!childrenArray.length) return

        const totalPages = Math.ceil(childrenArray.length / itemsPerPage)

        interval.current = setInterval(() => {
            setPage(prev => {
                const next = prev >= totalPages ? 1 : prev + 1
                setanimationClass(prev >= totalPages ? "slide-in-left" : "slide-in-right")
                onPageChange?.(next)
                return next
            })
        }, timeout)

        return () => clearInterval(interval.current)
    }, [childrenArray.length, itemsPerPage, timeout])


    useEffect(() => {
        const totalPages = Math.ceil(childrenArray.length / itemsPerPage)
        if (page > totalPages) setPage(1)
    }, [childrenArray.length, itemsPerPage])


    return (
        <div className={cx("flex-carousel", className)}>
            <div className={cx("flex-carousel__content", contentClassName)}>
                {childrenArray
                    .filter((child, index) => {
                        const startIndex = (page - 1) * itemsPerPage
                        const endIndex = startIndex + itemsPerPage
                        return index >= startIndex && index < endIndex
                    })
                    .map((child, index) => (
                        <div key={index} className={animationClass}>
                            {child}
                        </div>
                    ))}
            </div>
            <div className={`flex-carousel__pages ${innerPaginator ? "inner" : ""}`}>
                {Array.from({ length: Math.ceil(childrenArray.length / itemsPerPage) }).map((_i, index) => (
                    <div
                        key={index}
                        className={`flex-carousel__page ${index + 1 === page ? "active" : ""}`}
                        onClick={() => {
                            setPage(index + 1)
                            setanimationClass(index + 1 > page ? "slide-in-right" : "slide-in-left")
                            if (onPageChange) onPageChange(index + 1)
                        }}
                    ></div>
                ))}
            </div>
        </div>
    )
}

export default Carousel
